// @generated by protoc-gen-es v2.10.2
// @generated from file lda/v1alpha1/sample.proto (package lda, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, serviceDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file lda/v1alpha1/sample.proto.
 */
export const file_lda_v1alpha1_sample = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * Describes the message lda.BAMFileAccessType.
 * Use `create(BAMFileAccessTypeSchema)` to create a new message.
 */
export const BAMFileAccessTypeSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 0);

/**
 * Describes the message lda.VCFFileAccessType.
 * Use `create(VCFFileAccessTypeSchema)` to create a new message.
 */
export const VCFFileAccessTypeSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 1);

/**
 * Describes the message lda.FASTQFileAccessType.
 * Use `create(FASTQFileAccessTypeSchema)` to create a new message.
 */
export const FASTQFileAccessTypeSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 2);

/**
 * Describes the message lda.Sample.
 * Use `create(SampleSchema)` to create a new message.
 */
export const SampleSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 3);

/**
 * Describes the message lda.SampleFile.
 * Use `create(SampleFileSchema)` to create a new message.
 */
export const SampleFileSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 4);

/**
 * Describes the message lda.ListSamplesRequest.
 * Use `create(ListSamplesRequestSchema)` to create a new message.
 */
export const ListSamplesRequestSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 5);

/**
 * Describes the message lda.ListSamplesResponse.
 * Use `create(ListSamplesResponseSchema)` to create a new message.
 */
export const ListSamplesResponseSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 6);

/**
 * Describes the message lda.GetSampleRequest.
 * Use `create(GetSampleRequestSchema)` to create a new message.
 */
export const GetSampleRequestSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 7);

/**
 * Describes the message lda.GetSampleResponse.
 * Use `create(GetSampleResponseSchema)` to create a new message.
 */
export const GetSampleResponseSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 8);

/**
 * Describes the message lda.LaunchFileAccessJobRequest.
 * Use `create(LaunchFileAccessJobRequestSchema)` to create a new message.
 */
export const LaunchFileAccessJobRequestSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 9);

/**
 * Describes the message lda.LaunchFileAccessJobResponse.
 * Use `create(LaunchFileAccessJobResponseSchema)` to create a new message.
 */
export const LaunchFileAccessJobResponseSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 10);

/**
 * Describes the message lda.GetFileAccessJobStatusRequest.
 * Use `create(GetFileAccessJobStatusRequestSchema)` to create a new message.
 */
export const GetFileAccessJobStatusRequestSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 11);

/**
 * Describes the message lda.GetFileAccessJobStatusResponse.
 * Use `create(GetFileAccessJobStatusResponseSchema)` to create a new message.
 */
export const GetFileAccessJobStatusResponseSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 12);

/**
 * Describes the message lda.GetFileAccessJobStatusResponse.FileReady.
 * Use `create(GetFileAccessJobStatusResponse_FileReadySchema)` to create a new message.
 */
export const GetFileAccessJobStatusResponse_FileReadySchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 12, 0);

/**
 * Describes the message lda.CanSampleBeRestoredRequest.
 * Use `create(CanSampleBeRestoredRequestSchema)` to create a new message.
 */
export const CanSampleBeRestoredRequestSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 13);

/**
 * Describes the message lda.CanSampleBeRestoredResponse.
 * Use `create(CanSampleBeRestoredResponseSchema)` to create a new message.
 */
export const CanSampleBeRestoredResponseSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 14);

/**
 * Describes the message lda.RegisterSampleRequest.
 * Use `create(RegisterSampleRequestSchema)` to create a new message.
 */
export const RegisterSampleRequestSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 15);

/**
 * Describes the message lda.RegisterSampleResponse.
 * Use `create(RegisterSampleResponseSchema)` to create a new message.
 */
export const RegisterSampleResponseSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 16);

/**
 * Describes the message lda.GetUnassociatedSamplesRequest.
 * Use `create(GetUnassociatedSamplesRequestSchema)` to create a new message.
 */
export const GetUnassociatedSamplesRequestSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 17);

/**
 * Describes the message lda.GetUnassociatedSamplesResponse.
 * Use `create(GetUnassociatedSamplesResponseSchema)` to create a new message.
 */
export const GetUnassociatedSamplesResponseSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 18);

/**
 * Describes the message lda.GetUnassociatedSamplesResponse.UnassociatedSample.
 * Use `create(GetUnassociatedSamplesResponse_UnassociatedSampleSchema)` to create a new message.
 */
export const GetUnassociatedSamplesResponse_UnassociatedSampleSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_sample, 18, 0);

/**
 * Describes the enum lda.SampleStatus.
 */
export const SampleStatusSchema = /*@__PURE__*/
  enumDesc(file_lda_v1alpha1_sample, 0);

/**
 * @generated from enum lda.SampleStatus
 */
export const SampleStatus = /*@__PURE__*/
  tsEnum(SampleStatusSchema);

/**
 * @generated from service lda.SampleService
 */
export const SampleService = /*@__PURE__*/
  serviceDesc(file_lda_v1alpha1_sample, 0);

